/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteArray } from '../../models/delivery-note-array';
import { KeyType } from '../../models/key-type';

export interface GetDeliveryNoteMetadataInBundle$Params {
  organizationSiteKey: KeyType;
  deliveryNoteBundleKey: KeyType;
}

export function getDeliveryNoteMetadataInBundle(http: HttpClient, rootUrl: string, params: GetDeliveryNoteMetadataInBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteArray>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryNoteMetadataInBundle.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteBundleKey', params.deliveryNoteBundleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteArray>;
    })
  );
}

getDeliveryNoteMetadataInBundle.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles/{deliveryNoteBundleKey}/delivery-notes';
